import React from "react";
import { colors2 } from "oolib";
import { UI_BODY_SM_DF, UI_CAPTION_DF } from "oolib/dist/v2/components/Typo2";

/**
 * Where a speaker appears, in two lines: "2 datasets · 4 documents" over
 * the dataset titles. Reads `datasets` ([{ display }]) and `documents`
 * off the row; set `valuePath` to an always-present field (`id`). Needs
 * a taller `tableConfig.rowHeight` (two lines).
 */
const plural = (n, one, many) => `${(n || 0).toLocaleString()} ${n === 1 ? one : many}`;
const oneLine = { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "block", minWidth: 0 };

const TableDatasetsDocuments = ({ tableRowData }) => {
  const datasets = tableRowData?.datasets || [];
  const titles = datasets.map((d) => d.display).join(" · ");
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.2rem", minWidth: 0, width: "100%" }} title={titles}>
      <UI_BODY_SM_DF style={{ ...oneLine, color: colors2.grey80 }}>
        {plural(datasets.length, "dataset", "datasets")} · {plural(tableRowData?.documents, "document", "documents")}
      </UI_BODY_SM_DF>
      <UI_CAPTION_DF style={{ ...oneLine, color: colors2.grey60 }}>{titles}</UI_CAPTION_DF>
    </div>
  );
};

export default TableDatasetsDocuments;
